import gql from 'graphql-tag';
const I_KEYBOARDING_ACTIVITY_FRAGMENT = gql `
  fragment IKeyboardingActivityFragment on IKeyboardingActivity {
    id
    title
    description
    category
    activityTypeVariantId
    activityTypeVariant {
      id
      name
      variant
      activityTypeId
      activityType {
        id
        name
        type
      }
    }
    productCurriculums {
      id
      name
      product {
        id
        name
      }
    }
  }
`;
export default I_KEYBOARDING_ACTIVITY_FRAGMENT;
